import { render, staticRenderFns } from "./moneyDetial.vue?vue&type=template&id=5370fe3c&scoped=true&"
import script from "./moneyDetial.vue?vue&type=script&lang=js&"
export * from "./moneyDetial.vue?vue&type=script&lang=js&"
import style0 from "./moneyDetial.vue?vue&type=style&index=0&id=5370fe3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5370fe3c",
  null
  
)

export default component.exports